import React from "react";
import { Box, Step, StepLabel, Stepper, Typography } from "@mui/material";
import { getLifecycleProgress, LIFECYCLE_STEPS } from "../common/lifecycleSteps";
import { getStatusLabel } from "../common/statusColors";
import { FILTER_FONT_SIZE } from "../common/filterBarStyles";

/**
 * Horizontal milestone stepper — highlights where this request is in the pipeline.
 */
const StatusProgressStepper = ({ status }) => {
  const { activeIndex, terminal, terminalLabel } = getLifecycleProgress(status);
  const currentLabel = terminalLabel || getStatusLabel(status);

  return (
    <Box sx={{ mb: 2.5, overflowX: "auto", pb: 0.5 }}>
      <Stepper
        activeStep={activeIndex}
        alternativeLabel
        sx={{
          minWidth: 520,
          "& .MuiStepLabel-label": {
            fontSize: 11,
            fontWeight: 500,
            mt: 0.5,
          },
          "& .MuiStepLabel-label.Mui-active": {
            fontWeight: 700,
            color: terminal === "failed" ? "error.main" : terminal === "cancelled" ? "text.secondary" : "primary.main",
          },
          "& .MuiStepLabel-label.Mui-completed": {
            fontWeight: 500,
          },
          "& .MuiStepIcon-root.Mui-active": {
            color: terminal === "failed" ? "error.main" : terminal === "cancelled" ? "grey.500" : "primary.main",
          },
          "& .MuiStepIcon-root.Mui-completed": {
            color: "success.main",
          },
        }}
      >
        {LIFECYCLE_STEPS.map((step, index) => {
          const isCurrent = index === activeIndex;
          const label =
            isCurrent && terminal ? terminalLabel : step.label;
          return (
            <Step key={step.id} completed={index < activeIndex && !terminal}>
              <StepLabel
                error={isCurrent && terminal === "failed"}
                optional={
                  isCurrent && !terminal ? (
                    <Typography variant="caption" sx={{ fontSize: 10, color: "primary.main", fontWeight: 600 }}>
                      Now
                    </Typography>
                  ) : undefined
                }
              >
                {label}
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: "block", textAlign: "center", mt: 0.75, fontSize: FILTER_FONT_SIZE }}
      >
        Current status: <strong>{currentLabel}</strong>
      </Typography>
    </Box>
  );
};

export default StatusProgressStepper;
